/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Abandon_Vekn_TooltipInputs */



/**
* | output |
* | --- |
* | "Abandon VEKN ID" |
*
* @param {Profile_Abandon_Vekn_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_abandon_vekn_tooltip = /** @type {((inputs?: Profile_Abandon_Vekn_TooltipInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Abandon_Vekn_TooltipInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandonner le VEKN ID")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abandonar ID VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Abandonar VEKN ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbandona VEKN ID")
	return /** @type {LocalizedString} */ ("Abandon VEKN ID")
});